import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Pipeline from "@/pages/Pipeline";
import Prospects from "@/pages/Prospects";
import Playbook from "@/pages/Playbook";
import Resources from "@/pages/Resources";
import MyDay from "@/pages/MyDay";
import Intake from "@/pages/Intake";
import ICP from "@/pages/ICP";
import Analytics from "@/pages/Analytics";
import Templates from "@/pages/Templates";
import Won from "@/pages/Won";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 font-mono text-sm">Loading Sales IQ…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Pipeline />} />
              <Route path="prospects" element={<Prospects />} />
              <Route path="playbook" element={<Playbook />} />
              <Route path="resources" element={<Resources />} />
              <Route path="myday" element={<MyDay />} />
              <Route path="intake" element={<Intake />} />
              <Route path="icp" element={<ICP />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="reports" element={<Reports />} />
              <Route path="templates" element={<Templates />} />
              <Route path="won" element={<Won />} />
              <Route path="users" element={<Users />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
